import React from 'react';
import Pagify from 'react-pagify';
import segmentize from 'segmentize';
import { aggregatedClasses } from '@elliemae/ds-classnames';

var blockName = 'data-grid';
var PaginationContainer = aggregatedClasses('div')(blockName, 'pagination');
var PagifyContext = aggregatedClasses(Pagify.Context)(blockName, 'pagify-pagination');

var Paginator = function Paginator(_ref) {
  var pagination = _ref.pagination,
      pages = _ref.pages,
      _onSelect = _ref.onSelect,
      _ref$labelPrevious = _ref.labelPrevious,
      labelPrevious = _ref$labelPrevious === void 0 ? 'Previous' : _ref$labelPrevious,
      _ref$labelNext = _ref.labelNext,
      labelNext = _ref$labelNext === void 0 ? 'Next' : _ref$labelNext;
  var prevPage = pagination.page - 1;
  var nextPage = pagination.page + 1;
  return /*#__PURE__*/React.createElement(PaginationContainer, null, /*#__PURE__*/React.createElement(PagifyContext, {
    onSelect: function onSelect(page) {
      return page !== pagination.page && _onSelect(page);
    },
    segments: segmentize({
      page: pagination.page,
      pages: pages,
      beginPages: 1,
      endPages: 1,
      sidePages: 1
    })
  }, /*#__PURE__*/React.createElement(Pagify.Button, {
    className: pagination.page <= 1 ? 'button-disabled' : '',
    page: prevPage
  }, labelPrevious), /*#__PURE__*/React.createElement(Pagify.Segment, {
    field: "beginPages"
  }), /*#__PURE__*/React.createElement(Pagify.Ellipsis, {
    className: "ellipsis",
    nextField: "previousPages",
    previousField: "beginPages"
  }), /*#__PURE__*/React.createElement(Pagify.Segment, {
    field: "previousPages"
  }), /*#__PURE__*/React.createElement(Pagify.Segment, {
    className: "selected",
    field: "centerPage"
  }), /*#__PURE__*/React.createElement(Pagify.Segment, {
    field: "nextPages"
  }), /*#__PURE__*/React.createElement(Pagify.Ellipsis, {
    className: "ellipsis",
    nextField: "endPages",
    previousField: "nextPages"
  }), /*#__PURE__*/React.createElement(Pagify.Segment, {
    field: "endPages"
  }), /*#__PURE__*/React.createElement(Pagify.Button, {
    className: pagination.page >= pages ? 'button-disabled' : '',
    page: nextPage
  }, labelNext)));
};

export default Paginator;
//# sourceMappingURL=Paginator.js.map
